import { Command as C } from 'cmdk';
import { Search } from 'lucide-react';
import { Dialog as D } from 'radix-ui';
import { type ReactNode } from 'react';

import { estiloVeu } from './dialog';

export interface GrupoComando {
  titulo: string;
  itens: readonly {
    id: string;
    rotulo: string;
    icone?: ReactNode;
    atalho?: string;
    aoSelecionar: () => void;
  }[];
}

interface CommandProps {
  aberto: boolean;
  aoMudar: (aberto: boolean) => void;
  grupos: readonly GrupoComando[];
  placeholder?: string;
}

/** Paleta de comandos (⌘K): busca e executa ações e navegação pelo teclado. */
export function CommandDialog({
  aberto,
  aoMudar,
  grupos,
  placeholder = 'Buscar telas e ações',
}: CommandProps) {
  return (
    <D.Root open={aberto} onOpenChange={aoMudar}>
      <D.Portal>
        <D.Overlay className={estiloVeu} />
        <D.Content className="fixed left-1/2 top-[18vh] z-50 w-dialogo -translate-x-1/2 overflow-hidden rounded-painel border border-borda bg-superficie-elevada shadow-alta animate-surgir">
          <D.Title className="sr-only">Paleta de comandos</D.Title>
          <D.Description className="sr-only">
            Digite para filtrar e Enter para executar
          </D.Description>
          <C label="Paleta de comandos" loop>
            <div className="flex items-center gap-2 border-b border-borda px-4">
              <Search className="size-4 text-texto-fraco" aria-hidden />
              <C.Input
                placeholder={placeholder}
                className="h-12 w-full bg-transparent text-base outline-none placeholder:text-texto-fraco"
              />
            </div>
            <C.List className="max-h-80 overflow-y-auto p-2">
              <C.Empty className="px-3 py-6 text-center text-sm text-texto-fraco">
                Nada encontrado.
              </C.Empty>
              {grupos.map((grupo) => (
                <C.Group
                  key={grupo.titulo}
                  heading={grupo.titulo}
                  className="[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:text-texto-fraco"
                >
                  {grupo.itens.map((item) => (
                    <C.Item
                      key={item.id}
                      value={`${grupo.titulo} ${item.rotulo}`}
                      onSelect={() => {
                        aoMudar(false);
                        item.aoSelecionar();
                      }}
                      className="flex cursor-default items-center gap-2.5 rounded-controle px-2.5 py-2 text-base data-[selected=true]:bg-superficie-selecao [&_svg]:size-4 [&_svg]:text-texto-suave"
                    >
                      {item.icone}
                      <span className="flex-1">{item.rotulo}</span>
                      {item.atalho && (
                        <kbd className="font-mono text-xs text-texto-fraco">{item.atalho}</kbd>
                      )}
                    </C.Item>
                  ))}
                </C.Group>
              ))}
            </C.List>
          </C>
        </D.Content>
      </D.Portal>
    </D.Root>
  );
}
